import { render, staticRenderFns } from "./ServiceTrashCanItem.vue?vue&type=template&id=1d6c6d12&scoped=true&"
import script from "./ServiceTrashCanItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceTrashCanItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTrashCanItem.vue?vue&type=style&index=0&id=1d6c6d12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c6d12",
  null
  
)

export default component.exports